import React from "react";
import styles from "./start-page.module.css";
import {Page} from "../../components/page/page";
import {SliderTitle} from "../../components/slick-title/slick-title";
import GirlImage from "../../images/girl-bg-desk.png";

const StartPage = () => {
  const titleWithSlider = (
    <div>
      What Does the Future Hold for You...
      <SliderTitle />
    </div>
  );
  return (
    <div className={styles.bg_start_page}>
      <Page
        title={titleWithSlider}
        nextPageLink="./aspect"
        hideSteps={true}
        btnText="Let's Find Out!"
      >
        <img src={GirlImage} className={styles.mainImage} alt="AstroGirl" />
      </Page>
    </div>
  );
};

export { StartPage };
